import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as action from '../redux/actions';
import { Header, Content, Footer } from '../components';


const Container = ({ children }) => (
  <div className="editor_layer_type4">
    <div className="inner_editor_layer inner_youtube_layer">
      {children}
    </div>
  </div>
);

function YoutubeSearchTool (layerProp) {
  const editor = window.tinymce.activeEditor;

  const dispatch = useDispatch();

  const state = useSelector(_state => ({
    ..._state.plugins.YoutubeSearch,
    ..._state.editor,
  }));

  const handler = {
    updateSearchQuery,
    updateSortOption,
    searchVideos,
    searchMoreVideos,
    closeModal,
    insertVideoToEditor,
    openSortLayer,
    closeSortLayer,
  };

  const props = { ...state, ...handler };

  return (
    <Container>
      <Header {...props} />
      <Content {...props} />
      <Footer {...props} />
    </Container>
  );


  function updateSearchQuery ({ target }) {
    dispatch(action.setYoutubeSearchQuery(target.value));
  }

  function updateSortOption (value) {
    dispatch(action.setYoutubeSortOption(value));
  }

  function searchVideos () {
    dispatch(action.fetchYoutubeVideos());
  }

  function searchMoreVideos () {
    dispatch(action.fetchMoreYoutubeVideos());
  }

  function closeModal () {
    dispatch(action.clearYoutubeState());
    layerProp.closeModal();
  }

  function openSortLayer () {
    dispatch(action.openYoutubeSortLayer());
  }

  function closeSortLayer () {
    dispatch(action.closeYoutubeSortLayer());
  }

  function insertVideoToEditor (videoId) {
    editor.selection.setRng(state.selectionRange);
    editor.execCommand('makeOpengraphWithUrl', `https://www.youtube.com/watch?v=${videoId}`);
  }
}

export default YoutubeSearchTool;
